// extracted by mini-css-extract-plugin
module.exports = {"bar":"ContactBar_bar__3LV--","container":"ContactBar_container__3yIN-","mobile":"ContactBar_mobile__3HJv4","desktop":"ContactBar_desktop__3YZCX","hide":"ContactBar_hide__1Uz2i"};